import { Fragment, useState } from "react";
import withDashboard from "../../HOC/withDashboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import {
    ButtonBase,
    Button,
    InputAdornment,
    TextField,
    Card,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../../components/Loader";
import Pagination from "../../components/Pagination";
import SearchIcon from "@mui/icons-material/Search";

import {
    getBtcTransactions,
    setBtc,
    setSearchBtcTransaction,
} from "../../redux/actions/btcAction";
import {
    getEthTransactions,
    setETH,
    setSearchEthTransaction,
} from "../../redux/actions/ethAction";
import {
    getUsdtTransactions,
    setSearchUsdtTransaction,
    setUSDT,
} from "../../redux/actions/usdtAction";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PreviewIcon from "@mui/icons-material/Preview";
import {
    getReferralUsers,
    setSearchUser,
    setUser,
    setUserDetailProfile,
} from "../../redux/actions/userAction";
import Axios from "axios";
import { BASE_URL } from "../../redux/actions/types";

const ViewReferrals = () => {
    const [open, setOpen] = useState(false);
    const [user, setSelectedUser] = useState(null);

    const handleOpen = (user) => {
        setSelectedUser(user);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedUser(null);
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const User = useSelector(({ User }) => User);

    const {
        selectedCoin,
        users,
        filteredUsers,
        paginatedUsers,
        currentUserPage,
        totalUserPages,
        userPerPage,
        userSearch,
        selectedUser,
    } = User;
    console.log({ User });
    useEffect(() => {
        // eslint-disable-next-line
    }, []);

    const setTotalPages = (totalpages) => {
        dispatch(
            setUser({
                name: "totalUserPages",
                value: totalpages,
            })
        );
    };
    const setCurrentPage = (currentPage) => {
        dispatch(
            setUser({
                name: "currentUserPage",
                value: currentPage,
            })
        );
    };
    const setPaginatedItems = (paginatedItems) => {
        dispatch(
            setUser({
                name: "paginatedUsers",
                value: paginatedItems,
            })
        );
    };
    const handleChangeRowsPerPage = (event) => {
        const value = event.target.value;
        dispatch(
            setUser({
                name: "userPerPage",
                value,
            })
        );
    };

    const onSearch = (e) => {
        const value = e.target.value;
        dispatch(setSearchUser(value));
    };

    const formatAddress = (address) => {
        return `${address?.slice(0, 4)}...${address?.slice(-4)}`;
    };

    const onViewUser = (user) => {
        dispatch(
            setUser({
                name: "selectedUser",
                value: user,
            })
        );
        dispatch(setUserDetailProfile(user));
        navigate("/viewUserDetail");
    };

    const onReferralViewUser = (user) => {
        dispatch(
            setUser({
                name: "selectedUser",
                value: user,
            })
        );
        dispatch(setUserDetailProfile(user));
        navigate("/viewReferralUserDetail");
    };

    useEffect(() => {
        dispatch(getReferralUsers(selectedUser?.referralCode));
        // eslint-disable-next-line
    }, []);
    console.log({ User });

    return (
        <Fragment>
            <div className="table-layout-container">
                <Card className="table-card">
                    <div className="table-title">
                        <span>List of Referral Users</span>
                    </div>
                    <div className="table-container">
                        <table>
                            <thead>
                                <th>Name</th>
                                <th>Email</th>
                                <th>PhoneNumber</th>
                                <th>Transaction Count</th>
                                <th>Bonus Status</th>
                            </thead>
                            <tbody>
                                {filteredUsers.map((user) => {
                                    const bitcoinAddress = user?.bitcoin
                                        ? formatAddress(
                                              user?.bitcoin?.walletAddress
                                          )
                                        : "N/A";
                                    const etherAddress = user?.ethereum
                                        ? formatAddress(user?.ethereum?.address)
                                        : "N/A";
                                    return (
                                        <Fragment>
                                            <tr>
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.phoneNumber}</td>
                                                <td>
                                                    {`${
                                                        user?.transactionBonusCount ||
                                                        0
                                                    }/${
                                                        User?.enviroment &&
                                                        User.enviroment !==
                                                            "test"
                                                            ? User?.prodConfig
                                                                  ?.REFERRAL_TRANSACTION_COUNT
                                                            : User?.testConfig
                                                                  ?.REFERRAL_TRANSACTION_COUNT ||
                                                              0
                                                    }`}
                                                </td>
                                                <td>
                                                    {user?.referPersonBonusGiven
                                                        ? "Completed"
                                                        : "Pending"}
                                                </td>
                                            </tr>
                                        </Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth="xs"
                        fullWidth>
                        <DialogTitle
                            sx={{ textAlign: "center", fontWeight: "bold" }}>
                            Confirm Deletion
                        </DialogTitle>
                        <DialogContent sx={{ textAlign: "center", py: 2 }}>
                            <DeleteIcon
                                sx={{ fontSize: 40, color: "red", mb: 2 }}
                            />
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                Are you sure you want to delete user{" "}
                                <Typography
                                    component="span"
                                    sx={{
                                        fontWeight: "bold",
                                        color: "primary.main",
                                    }}>
                                    {user?.name}
                                </Typography>
                                ?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                This action cannot be undone.
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                            <Button
                                onClick={handleClose}
                                variant="outlined"
                                sx={{ mx: 1 }}>
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Pagination
                        currentPage={currentUserPage}
                        setCurrentPage={setCurrentPage}
                        items={filteredUsers}
                        totalPages={totalUserPages}
                        setTotalPages={setTotalPages}
                        itemsPerPage={userPerPage}
                        setPaginatedItems={setPaginatedItems}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                    <Loader />
                </Card>
            </div>
        </Fragment>
    );
};

export default withDashboard(ViewReferrals);
